import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
    imports: [MatCardModule, MatButtonModule]
})
export class AboutComponent {
    /**
     * Numéro de version de l'application.
     */
    public version: string = environment.version;

    /**
     * Constructeur.
     * @param dialogRef
     */
    constructor(public dialogRef: MatDialogRef<AboutComponent>) {}

    /**
     * Appelée lorsque l'utilisateur clique sur le bouton 'Fermer'.
     */
    public close(): void {
        this.dialogRef.close();
    }
}
